<script setup>
import { ref, onMounted, computed } from 'vue';
import TreeTable from 'primevue/treetable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import { useRbacStore } from '@/stores/rbac.js';
import { useConfirm } from 'primevue/useconfirm';
import ButtonGroup from "primevue/buttongroup";

const emit = defineEmits(['edit', 'delete', 'configure-permissions']);

const rbacStore = useRbacStore();
const confirm = useConfirm();

const loading = computed(() => rbacStore.loading.departments);

// Преобразуем дерево отделов в формат для TreeTable
const treeNodes = computed(() => {
  return convertToTreeNodes(rbacStore.departmentsTree);
});

function convertToTreeNodes(departments) {
  return departments.map(dept => ({
    key: String(dept.id),
    data: {
      id: dept.id,
      name: dept.name,
      parent_name: dept.parent_name || '—',
      head_name: dept.head_name || '—',
      group_name: dept.group_name || '—',
      created_at: dept.created_at,
    },
    children: dept.children && dept.children.length > 0
      ? convertToTreeNodes(dept.children)
      : []
  }));
}

onMounted(async () => {
  await rbacStore.loadDepartments();
});

function handleEdit(node) {
  const flatDept = rbacStore.getDepartmentById(node.data.id);
  emit('edit', flatDept);
}

function handleDelete(node) {
  confirm.require({
    message: `Удалить отдел "${node.data.name}"?`,
    header: 'Подтверждение',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Удалить',
    rejectLabel: 'Отмена',
    accept: () => {
      const flatDept = rbacStore.getDepartmentById(node.data.id);
      emit('delete', flatDept);
    }
  });
}

function handleConfigurePermissions(node) {
  const flatDept = rbacStore.getDepartmentById(node.data.id);
  emit('configure-permissions', flatDept);
}

function formatDate(dateString) {
  if (!dateString) return '—';
  const date = new Date(dateString);
  return date.toLocaleDateString('ru-RU');
}
</script>

<template>
  <div class="h-full flex flex-col">
    <TreeTable
      :value="treeNodes"
      :loading="loading"
      scrollable
      scroll-height="flex"
      class="flex-1"
    >
      <Column field="name" header="Название" expander style="min-width: 250px"></Column>
      <Column field="head_name" header="Руководитель" style="min-width: 200px"></Column>
      <Column header="Действия" style="min-width: 280px">
        <template #body="{ node }">
          <div class="flex gap-2">
            <ButtonGroup>
            <Button
              icon="pi pi-key"
              severity="secondary"
              size="small"
              rounded
              text
              @click="handleConfigurePermissions(node)"
            />
            <Button
              icon="pi pi-pencil"
              severity="secondary"
              size="small"
              rounded
              text
              @click="handleEdit(node)"
            />
            <Button
              icon="pi pi-trash"
              severity="warn"
              size="small"
              rounded
              text
              @click="handleDelete(node)"
            />
            </ButtonGroup>
          </div>
        </template>
      </Column>
    </TreeTable>
  </div>
</template>

<style scoped>
</style>
